import { path } from 'ramda';
import replaceStringPlaceholders from '../../common/replaceStringPlaceholders';
import { IS_CLIENT } from '../../constants';
import showCopyKeys from '../showCopyKeys';
const getLabel = ({ copyKey, replacements, allLabels }) => {
    if (showCopyKeys()) {
        return copyKey;
    }
    if (allLabels) {
        const labelValue = allLabels[copyKey];
        if (labelValue) {
            if (replacements || replacements === 0) {
                return replaceStringPlaceholders(labelValue, replacements);
            }
            return labelValue;
        }
        if (replacements) {
            return replaceStringPlaceholders(copyKey, replacements);
        }
    }
    // TODO: remove usage of window.hm.i18n, to use AEMs API translation
    if (copyKey) {
        const hmI18nCopy = path(['hm', 'i18n', ...copyKey.split('.')], IS_CLIENT && window) || '';
        if (hmI18nCopy) {
            return hmI18nCopy;
        }
    }
    return copyKey;
};
export default getLabel;
//# sourceMappingURL=getLabel.js.map